import { http, useAPI, isFetchError } from '~~core';

import { signerSchema } from '../schemas/signer';
import { signerUserSchema, SignerUser } from '../schemas/user';

export async function fetchSignerInfo(signatureRequestKey: string) {
  const { getEndpoint } = useAPI(signatureRequestKey);

  const data = await http(getEndpoint(''), {
    method: 'get',
  });

  return signerSchema.parse(data);
}

export async function fetchSignerUser() {
  let user = {
    name: null,
    cpf: null,
    birthday: null,
  };

  try {
    const { data } = await http('/operator', { method: 'get' });

    user = data.user;
  } catch (err) {
    if (!isFetchError(err)) throw err;
  }

  const { name: fullName, cpf: documentation, birthday } = user;

  return signerUserSchema.parse({ fullName, documentation, birthday });
}

export async function saveSignerUser(payload: SignerUser) {
  const user = { name: payload.fullName, cpf: payload.documentation, birthday: payload.birthday };

  return http('/operator', {
    method: 'PATCH',
    body: { user },
  });
}
